
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_34487","data-name":"Group 34487","transform":"translate(481.204 -511.912)"}},[_c('g',{attrs:{"id":"Group_34147","data-name":"Group 34147"}},[_c('g',{attrs:{"id":"Rectangle_9547","data-name":"Rectangle 9547"}},[_c('rect',{attrs:{"id":"Rectangle_9612","data-name":"Rectangle 9612","width":"30","height":"30","rx":"6","transform":"translate(-481.204 511.912)","fill":"#fff"}}),_c('rect',{attrs:{"id":"Rectangle_9613","data-name":"Rectangle 9613","width":"29","height":"29","rx":"5.5","transform":"translate(-480.704 512.412)","fill":"none","stroke":"#ecedf2","stroke-width":"1"}})])]),_c('g',{attrs:{"id":"Group_34090","data-name":"Group 34090"}},[_c('g',{attrs:{"id":"Ellipse_261","data-name":"Ellipse 261"}},[_c('path',{attrs:{"id":"Path_19954","data-name":"Path 19954","d":"M-463.726 533.665a7.334 7.334 0 01-9.616-3.885 7.333 7.333 0 013.885-9.615 7.333 7.333 0 019.616 3.884 7.335 7.335 0 01.087 5.517","fill":"none","stroke":"#1c84fa","stroke-miterlimit":"4.002","stroke-width":"2.001"}})])])])])
          )
        }
      }
    